import { useEffect, forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';

const frameContainer = document.body;
const loginFormContent =
  '<form id="login-form" method="post">' +
  '<input id="login" name="j_username" type="text"/>' +
  '<input id="password" name="j_password" type="password"/>' +
  '<input id="client_id" type="hidden" name="client_id"/>' +
  '<input id="return_url" type="hidden" name="returnUrl"/>' +
  '</form>';

const LoginIFrame = forwardRef(({ loginCallback, linkFrame }, ref) => {
  let frame = null;

  const renderFrame = () => {
    if (frame) {
      frame.removeEventListener('load', loginCallback);
      frameContainer.removeChild(frame);
    }

    frame = document.createElement('iframe');
    frame.src = 'about:blank';
    frame.hidden = true;
    frameContainer.appendChild(frame);

    frame.contentWindow.document.open('text/htmlreplace');
    frame.contentWindow.document.write(loginFormContent);
    frame.contentWindow.document.close();

    linkFrame(frame);
  };

  const removeFrame = () => {
    frame.removeEventListener('load', loginCallback);
    frameContainer.removeChild(frame);
  };

  useImperativeHandle(ref, () => ({
    renderFrame,
    removeFrame,
  }));

  useEffect(renderFrame, []);

  return null;
});

LoginIFrame.propTypes = {
  linkFrame: PropTypes.func.isRequired,
  loginCallback: PropTypes.func.isRequired,
};

export default LoginIFrame;
